module.exports = __webpack_public_path__ + "img/level4.4dd5d4b1.png";